document.addEventListener("DOMContentLoaded", () => {

  const modal = document.getElementById("NotifyModal");
  if (!modal) return;

  /* --------------------------------
      Modal Elements
  -------------------------------- */

  const overlay = modal.querySelector(".notify-modal__overlay");
  const closeBtn = modal.querySelector(".notify-modal__close");
  const form = modal.querySelector("form");

  /* --------------------------------
      Hidden Inputs
  -------------------------------- */

  const productInput = document.getElementById("NotifyProduct");
  const variantInput = document.getElementById("NotifyVariant");
  const skuInput = document.getElementById("NotifySku");
  const yearInput = document.getElementById("NotifyYear");
  const bedInput = document.getElementById("NotifyBed");
  const productUrlInput = document.getElementById("NotifyProductUrl");

  /* --------------------------------
      Display Inputs
  -------------------------------- */

  const productDisplay = document.getElementById("NotifyProductDisplay");
  const skuDisplay = document.getElementById("NotifySkuDisplay");
  const yearDisplay = document.getElementById("NotifyYearDisplay");
  const bedDisplay = document.getElementById("NotifyBedDisplay");

  let currentVariant = null;
  let currentProduct = "";
  let currentProductUrl = "";

  /* --------------------------------
      Store Current Variant
  -------------------------------- */

  function updateVariant(variant, sectionId) {

    if (!variant) return;

    currentVariant = variant;

    const productInfo = document.querySelector(
      `product-info[data-section="${sectionId}"]`
    );

    if (!productInfo) return;

    const notifyButton =
      productInfo.querySelector(".notify-me-button");

    currentProduct =
      notifyButton?.dataset.productTitle || "";

    currentProductUrl =
      notifyButton?.dataset.productUrl || "";

  }

  /* --------------------------------
      Dawn Variant Change
  -------------------------------- */

  if (typeof subscribe !== "undefined") {

    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {

      updateVariant(data.variant, data.sectionId);

    });

  }

  /* --------------------------------
      Initial Variant
  -------------------------------- */

  document.querySelectorAll("product-info").forEach((productInfo) => {

    const json = productInfo.querySelector(
      'variant-selects script[data-selected-variant]'
    );

    if (!json) return;

    try {

      updateVariant(
        JSON.parse(json.textContent),
        productInfo.dataset.section
      );

    } catch (e) {
      console.error(e);
    }

  });

  /* --------------------------------
      Open Popup
  -------------------------------- */

  document.addEventListener("click", function (e) {

    const button = e.target.closest(".notify-me-button");

    if (!button) return;

    if (currentVariant) {

      /* Hidden Fields */

      if (productInput)
        productInput.value = currentProduct;

      if (variantInput)
        variantInput.value = currentVariant.id;

      if (skuInput)
        skuInput.value = currentVariant.sku || "";

      if (yearInput)
        yearInput.value = currentVariant.option1 || "";

      if (bedInput)
        bedInput.value = currentVariant.option2 || "";

      if (productUrlInput)
        productUrlInput.value =
          currentProductUrl +
          "?variant=" +
          currentVariant.id;

      /* Readonly Display */

      if (productDisplay)
        productDisplay.value = currentProduct;

      if (skuDisplay)
        skuDisplay.value = button.dataset.partNumber|| "";

      if (yearDisplay)
        yearDisplay.value = currentVariant.option1 || "";

      if (bedDisplay)
        bedDisplay.value = currentVariant.option2 || "";

    }

    modal.classList.add("active");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("notify-modal-open");

  });

  /* --------------------------------
      Close Popup
  -------------------------------- */

  function closePopup() {

    modal.classList.remove("active");
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("notify-modal-open");

  }

  overlay?.addEventListener("click", closePopup);

  closeBtn?.addEventListener("click", closePopup);

  document.addEventListener("keydown", function (e) {

    if (e.key === "Escape") {

      closePopup();

    }

  });

  /* --------------------------------
      Prevent Double Submit
  -------------------------------- */

  if (form) {

    form.addEventListener("submit", function () {

      const submitButton =
        form.querySelector('button[type="submit"]');

      if (!submitButton) return;

      submitButton.disabled = true;
      submitButton.innerHTML = "Submitting...";

    });

  }

});